import { useMutation } from "@apollo/client";
import { graphql } from "../gql";
import { GetAllOneOnOneAssignmentPdfsQuery } from "./useAllOneOnOneAssignmentPdfs.ts";
import {
  BusinessEnglishObjective,
  OneOnOneLessonType,
  SpeakingClassLevel,
} from "../gql/graphql.ts";

const CreateOneOnOneAssignmentPdfMutation = graphql(`
  mutation createOneOnOneAssignmentPdf(
    $assignmentNumber: Int!
    $level: SpeakingClassLevel!
    $oneOnOneLessonType: OneOnOneLessonType!
    $pdfUrl: String!
    $userGroupId: String!
    $businessEnglishObjective: BusinessEnglishObjective
  ) {
    createOneOnOneAssignmentPdf(
      assignmentNumber: $assignmentNumber
      level: $level
      oneOnOneLessonType: $oneOnOneLessonType
      pdfUrl: $pdfUrl
      userGroupId: $userGroupId
      businessEnglishObjective: $businessEnglishObjective
    ) {
      assignmentNumber
      level
      oneOnOneLessonType
      pdfUrl
      userGroupId
      businessEnglishObjective
      userGroup {
        id
        name
      }
    }
  }
`);

export function useCreateOneOnOneAssignmentPdf() {
  const [mutate, { loading }] = useMutation(
    CreateOneOnOneAssignmentPdfMutation,
    {
      refetchQueries: [GetAllOneOnOneAssignmentPdfsQuery],
    },
  );

  return {
    loading,
    create: (input: {
      assignmentNumber: number;
      level: SpeakingClassLevel;
      oneOnOneLessonType: OneOnOneLessonType;
      pdfUrl: string;
      userGroupId: string;
      businessEnglishObjective?: BusinessEnglishObjective;
    }) =>
      mutate({
        variables: input,
      }),
  };
}
